// 模块集中，导出
import User from "./user";
import Language from "./language";

export default {
    User,Language
}